import gql from 'graphql-tag';

export default gql`
    mutation SaveB2CUser($input: SaveB2CUserInput) {
        saveB2CUser(input: $input) {
            errors
        }
    }
`;
